import { FC } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { MDSLoadingArrowsProps, MDSLoadingArrowsSize } from "./loading-arrows.types";
import { StyledLoadingArrowsContainer } from "./loading-arrows.styles";
import loadingArrowsAnimation from "@/assets/images/loading-arrows-tomato.json";

export const MDSLoadingArrows: FC<MDSLoadingArrowsProps> = ({
  size = MDSLoadingArrowsSize.Medium,
  className,
  loop = true,
  speed = 1.0,
}) => {
  return (
    <StyledLoadingArrowsContainer size={size} className={className}>
      <DotLottieReact
        data={loadingArrowsAnimation}
        loop={loop}
        autoplay={loop}
        speed={speed}
        style={{ width: "100%", height: "100%" }}
      />
    </StyledLoadingArrowsContainer>
  );
};
